import { actions } from '../../../utils/constants';

const INITIAL_STATE = {
  isAdmin: false,
  form: {},
  inRequest: false,
  loadingUser: false,
  disabledModalButton: true,
  searchInput: '',
  listCoachs: [],
  formAdd: {}
}

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {

    case actions.SET_IS_ADMIN:
      return { ...state, isAdmin: payload };

    case actions.SET_IN_REQUEST:
      return { ...state, inRequest: payload };

    case actions.SET_LOADING_USER:
      return { ...state, loadingUser: payload };

    case actions.SET_MODAL_BUTTON:
      return { ...state, disabledModalButton: payload };

    case actions.SET_CREDENTIALS_VALUE:
      return { ...state, form: { ...state.form, [payload.id]: payload.value } };

    case actions.ADD_COACH:
      return { ...state, listCoachs: payload };

    case actions.SET_COACH_FORM_VALUE:
      return { ...state, formAdd: { ...state.formAdd, [payload.id]: payload.value } };

    case actions.SET_COACH_FORM_VALUE_COMPLETE:
      return { ...state, formAdd: payload };

    case actions.CLEAR_COACH_FORM_VALUE:
      return { ...state, formAdd: {} };

    case actions.SET_ADMIN_SEARCH_VALUE:
      return { ...state, searchInput: payload }

    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/App/containers/admin/admin.reducer.js